export const updateObject = (oldObj, updatedProps) => {
  return { ...oldObj, ...updatedProps };
};

export const checkValidity = (value, rules) => {
  let isValid = false;

  if (!rules) {
    return true;
  }

  if (rules.required) {
    isValid = value.trim() !== '';
  }

  if (rules.minLength) {
    isValid = isValid && value.length >= rules.minLength;
  }

  if (rules.maxLength) {
    isValid = isValid && value.length <= rules.maxLength;
  }

  return isValid;
};



// WEBPACK FOOTER //
// ./src/shared/utility.js